import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  notificationBodiesLength: 0,
  notificationBodies: [],
  notificationBody: {},
  notificationBodyError: "",
  formError: "",
};

export default function NotificationBodyReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_NOTIFICATION_BODY:      
      return { ...state, loading: action.payload };

    case actions.LOADING_NOTIFICATION_BODY_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_NOTIFICATION_BODY:
      return { ...state, saveLoading: action.payload };

    case actions.GET_NOTIFICATION_BODY:
      return {
        ...state,
        notificationBodies: action.payload.notificationBodies,
        notificationBodiesLength: action.payload.notificationBodiesLength,
      };

    case actions.GET_NOTIFICATION_BODY_BY_ID:
      return { ...state, notificationBody: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.NOTIFICATION_BODY_FAIL:
      return { ...state, notificationBodyError: action.payload };

    default:
      return state;
  }
}
